import React from 'react'
import { ErrorMessage, Formik, FormikHelpers } from 'formik'
import * as Yup from 'yup'
import { View } from 'react-native'

import tw from 'tailwind-rn'
import styles from './styles'
import { HGTextInput } from '../../components/Form'
import { HGButton, HGText } from '../../components/HGUI'

const validationSchema = Yup.object().shape({
  memberCode: Yup.string()
    .required('Bitte geben Sie einen Weiterbildungscode ein.')
    .min(3, 'Bitte geben Sie einen gültigen Weiterbildungscode ein.'),
})

export type SignUpFirstStepValues = {
  memberCode: string
}

const initialValues: SignUpFirstStepValues = {
  memberCode: '',
}

type Props = {
  onSubmit: (
    values: SignUpFirstStepValues,
    setSubmitting: (value: boolean) => void,
    setFieldError: (field: string, message: string) => void
  ) => void
}

const SignUpForm = (props: Props) => {
  const { onSubmit } = props

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(
        { memberCode }: SignUpFirstStepValues,
        { setSubmitting, setFieldError }: FormikHelpers<SignUpFirstStepValues>
      ) => {
        onSubmit({ memberCode }, setSubmitting, setFieldError)
      }}
      validateOnMount
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        isValid,
        values,
      }) => (
        <View>
          <HGTextInput
            onChangeText={handleChange('memberCode')}
            onBlur={handleBlur('memberCode')}
            value={values.memberCode}
            autoCapitalize="none"
            placeholder="Ihr Weiterbildungscode …"
            textContentType="oneTimeCode"
            // autoCorrect={false}
          />

          <ErrorMessage
            name="memberCode"
            render={(message) => (
              <HGText style={tw('text-sm mt-1 text-red-500')}>{message}</HGText>
            )}
          />

          <View style={tw('mt-6')}>
            <HGButton
              disabled={isSubmitting || !isValid}
              title={!isSubmitting ? 'Weiter' : 'Bitte warten …'}
              onPress={() => handleSubmit()}
            />
          </View>
        </View>
      )}
    </Formik>
  )
}

export default SignUpForm
